import type { SubServiceDetail } from '../types';

export const subservices: SubServiceDetail[] = [
  {
    "categorySlug": "video-produksiyon",
    "categoryTitle": "Film ve Video Prodüksiyon",
    "slug": "tanitim-filmi",
    "title": "Kurumsal ve Fabrika Tanıtım Filmi Çekimi",
    "metaTitle": "Fabrika & Kurumsal Tanıtım Filmi Çekimi - WE24 Agency İstanbul",
    "metaDescription": "Sanayi tesisleri, üretim hatları ve kurumsal markalar için 4K/6K sinematik fabrika tanıtım filmleri. Lisanslı drone çekimi ve DaVinci renk kalitesiyle küresel pazarlarda güven inşa edin.",
    "keywords": [
      "fabrika tanıtım filmi",
      "kurumsal film çekimi istanbul",
      "endüstriyel tanıtım videosu",
      "fabrika reklam filmi",
      "sanayi tesisi video prodüksiyon"
    ],
    "heroTagline": "Üretim gücünüzü ve teknoloji vizyonunuzu sinematik dille küresel pazarlara taşıyın.",
    "shortDescription": "Sanayi tesisleri, teknoloji merkezleri ve kurumsal markalar için üretim süreçlerini, kalite standartlarını ve global vizyonu dinamik sinema diliyle anlatan prestijli kurumsal tanıtım filmleri üretiyoruz.",
    "fullDescription": "WE24 Agency olarak, 15 yılı aşkın endüstriyel prodüksiyon tecrübemizle Türkiye'nin ve dünyanın önde gelen sanayi kuruluşlarına, fabrikalarına ve teknoloji şirketlerine özel tanıtım filmleri üretiyoruz. Ağır sanayi tesislerinden yüksek teknolojili cleanroom laboratuvarlarına kadar her üretim ortamının ruhunu; RED ve Sony sinema kameraları, özel korumalı FPV drone uçuşları ve anamorfik lenslerle büyüleyici bir görsel anlatıya dönüştürüyoruz.",
    "whyUs": [
      "15+ Yıllık Endüstriyel Set ve Fabrika Prodüksiyonu Tecrübesi",
      "Kendi Ekipman Parkurumuz (RED 6K, Sony FX Serisi, Anamorfik Lensler)",
      "SHGM Onaylı Lisanslı İHA Pilotları ile Tesis İçi & Dışı FPV Drone Çekimleri",
      "Çok Dilli Profesyonel Seslendirme (Native Voiceover) & Uluslararası Altyazı",
      "DaVinci Resolve ile Endüstriyel Renk Derecelendirmesi (Color Grading)"
    ],
    "deliverables": [
      "Ana Tanıtım Filmi (3:30 - 5:00 Dk 4K RAW Master)",
      "Fuar & Zirve Versiyonu (1 Dk Hızlı Ritimli Teaser)",
      "Sosyal Medya / LinkedIn Bölümleri (9:16 ve 1:1 Formatlar)",
      "Yüksek Çözünürlüklü Fabrika & Üretim Fotoğraf Arşivi",
      "TR, EN, DE, FR Çok Dilli Master Video Paketleri"
    ],
    "process": [
      "Keşif & Senaryo: Fabrika sahası incelenir, kritik üretim hatları ve çekim açıları belirlenerek akış senaryosu yazılır.",
      "İş Güvenliği & Pre-Prodüksiyon: Tesis İSG kurallarına tam uyumlu ekipman ve ışık planlaması yapılır.",
      "Sinematik Çekim Günleri: Yönetmen, görüntü yönetmeni, gimbal operatörü ve drone pilotu ile çekimler gerçekleştirilir.",
      "Post-Prodüksiyon & Renk: Kurgu, dinamik ses tasarımı (foley), DaVinci renk düzenleme ve 3D infografikler eklenir.",
      "Master Teslimatı: Tüm dijital ve fuar ekranlarına uygun yüksek bitrate master dosyalar teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Kamera & Lens",
        "items": [
          "RED 6K Sensor",
          "Sony FX9 & FX6",
          "Anamorphic Prime Lensler"
        ]
      },
      {
        "category": "Işık & Hareket",
        "items": [
          "Aputure 1200d & 600c LED",
          "Ronin 2 Gimbal",
          "FPV & Cinelifter Drone"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Bir Fabrika Tanıtım Filmi Neden Klasik Bir Video Değildir?",
        "content": "Endüstriyel alıcılar ve B2B partnerler, iş birliği yapacakları tesisin disiplinine, hijyenine, kapasitesine ve teknolojik gücüne bakarlar. Sıradan bir kamera kaydı fabrikayı sadece 'gösterirken', sinematik bir tanıtım filmi o fabrikayı 'güvenilir bir global tedarikçi' olarak konumlandırır. 1500 derecelik erimiş metalin ışıltısından robotik montaj kollarının mikrometrik hassasiyetine kadar her detay doğru ışık ve lens seçimiyle devleşir.",
        "subPoints": [
          "B2B İhracat Satışlarında İkna Süresini Kısaltır",
          "Uluslararası Fuarlarda Standınıza Yüksek Prestij Kazandırır",
          "Yatırımcı ve Denetim Süreçlerinde Güçlü Referans Sağlar"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Fabrika tanıtım filmi çekimleri üretimi aksatır mı?",
        "answer": "Hayır. Çekim planımız fabrika vardiyalarına ve İSG kurallarına tam uyumlu olarak organize edilir; aktif hatlarda iş akışını kesintiye uğratmadan profesyonel set disipliniyle çekim yapılır."
      },
      {
        "question": "Drone çekimleri kapalı fabrika alanlarında yapılabilir mi?",
        "answer": "Evet. Pervane korumalı özel FPV drone sistemlerimiz ve lisanslı pilotlarımız ile fabrika binalarının, fırınların ve hatların içinden güvenli geçişler yapabiliyoruz."
      }
    ],
    "relatedProjectSlugs": [
      "fabrika-tanitim-filmi-kutes-we24-agency-fabrika-reklam-filmi",
      "fabrika-tanitim-filmi-sapro-kurumsal-tanitim-filmi-we24-agency",
      "tanitim-filmi-3b-fab-we24-agency-fabrika-reklam-filmi"
    ]
  },
  {
    "categorySlug": "video-produksiyon",
    "categoryTitle": "Film ve Video Prodüksiyon",
    "slug": "reklam-filmi",
    "title": "Televizyon ve Dijital Reklam Filmi Prodüksiyonu",
    "metaTitle": "Reklam Filmi Çekimi & Prodüksiyon - WE24 Agency İstanbul",
    "metaDescription": "Ulusal TV kanalları ve dijital platformlar için yüksek prodüksiyon değerli reklam filmleri. Yaratıcı senaryo, oyuncu cast seçimi ve sinematik kurgu ile markanızı zirveye taşıyın.",
    "keywords": [
      "reklam filmi prodüksiyonu",
      "tv reklamı çekimi",
      "dijital reklam filmi",
      "reklam ajansı istanbul",
      "video reklam yönetmeni"
    ],
    "heroTagline": "Duygu yaratan senaryolar ve sinematik görsel güç ile hedef kitlenizi harekete geçirin.",
    "shortDescription": "Ulusal televizyon kanalları ve dijital mecralar (YouTube, Meta, TikTok) için hedef kitleyi harekete geçiren, akılda kalıcı ve yüksek prodüksiyon standartlarında reklam filmleri üretiyoruz.",
    "fullDescription": "Reklam filmi prodüksiyonu, bir markanın en prestijli vitrinidir. WE24 Agency olarak konsept geliştirmeden storyboard çizimine, profesyonel oyuncu ve cast yönetiminden set aydınlatması ve ses tasarımına kadar uçtan uca reklam prodüksiyonu gerçekleştiriyoruz.",
    "whyUs": [
      "Akılda Kalıcı Kreatif Senaryo & Hikaye Anlatımı",
      "Profesyonel Cast, Mekân ve Set Yönetimi",
      "ARRI & RED Sinema Kameralarıyla TV Standartlarında Görüntü",
      "Televizyon ve Dijital Yayınlara Uygun Ses Miksajı (R128 Standartı)"
    ],
    "deliverables": [
      "TV Master (4K/ProRes & MXF)",
      "Sosyal Medya Cutdown'ları (15s, 30s, 6s Bumper)",
      "9:16 Dikey Formatlar",
      "Sosyal Medya Teaser Paketi"
    ],
    "process": [
      "Kreatif Brief & Senaryo Yazımı",
      "Storyboard & Pre-Prodüksiyon (Cast / Kostüm / Sanat Yönetimi)",
      "Set & Çekim Günleri",
      "Kurgu, VFX, Renk & Ses Tasarımı",
      "Mecralara Göre Master Teslimatı"
    ],
    "techSpecs": [
      {
        "category": "Kamera & Lens",
        "items": [
          "ARRI Alexa Mini LF",
          "Cooke & Zeiss Cine Lensler"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Etkili Bir Reklam Filminin 3 Temel Direği",
        "content": "Bir reklam filminin başarısı yalnızca bütçesiyle değil; iletilen mesajın berraklığı, görsel ritmin akıcılığı ve izleyicide bıraktığı duyguyla ölçülür.",
        "subPoints": [
          "İlk 3 saniyede güçlü dikkat kancası",
          "Marka vaadiyle uyumlu duygusal ton",
          "Net ve güçlü eyleme çağrı (CTA)"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Reklam filmi ne kadar sürede tamamlanır?",
        "answer": "Senaryo onayından itibaren cast, çekim ve post-prodüksiyon süreçleri ortalama 2 ila 4 hafta içinde tamamlanır."
      }
    ],
    "relatedProjectSlugs": [
      "seger-fuar-tanitim-filmi",
      "arma-kontrol-reklam-filmi",
      "endocare-renewal-serisi-reklam-filmi"
    ]
  },
  {
    "categorySlug": "video-produksiyon",
    "categoryTitle": "Film ve Video Prodüksiyon",
    "slug": "muzik-video-klip",
    "title": "Müzik Video Klip Prodüksiyonu",
    "metaTitle": "Müzik Video Klip Çekimi & Yönetmenliği - WE24 Agency İstanbul",
    "metaDescription": "Sanatçılar ve plak şirketleri için şarkının ruhunu yansıtan sanatsal yönetmenlik, sinematik set ışığı ve dinamik kurgu ile profesyonel klip çekimleri.",
    "keywords": [
      "klip çekimi istanbul",
      "müzik video prodüksiyonu",
      "klip yönetmeni",
      "şarkı klibi çekimi",
      "youtube müzik videosu"
    ],
    "heroTagline": "Müziğin ritmini ve ruhunu sinematik bir görsel başyapıta dönüştürün.",
    "shortDescription": "Sanatçılar, müzik grupları ve plak şirketleri için şarkının atmosferini yansıtan yaratıcı konseptler, sanatsal ışık tasarımı ve dinamik kurguyla müzik video klipleri üretiyoruz.",
    "fullDescription": "Müzik klipleri sanatsal vizyonun en özgür ifade bulduğu alandır. Şarkının melodisinden sözlerine kadar her detayı analiz ederek sanatçıya ve şarkıya özgü görsel bir dünya inşa ediyoruz.",
    "whyUs": [
      "Sanatsal Yönetmenlik ve Görsel Konsept Geliştirme",
      "Dinamik Set Işıklandırması & Atmosfer Tasarımı",
      "YouTube & Müzik TV Kanalları İçin Kusursuz Format Uyumluluğu"
    ],
    "deliverables": [
      "4K Sinema Master Klip",
      "YouTube 16:9 4K Master",
      "Instagram & TikTok Teaser Reels (9:16)",
      "Klip Kapak Fotoğrafları"
    ],
    "process": [
      "Şarkı Analizi & Senaryo Geliştirme",
      "Mekân & Sanat Tasarımı",
      "Set & Klip Çekimi",
      "Ritmik Kurgu & Renk Tasarımı",
      "Lansman Öncesi Teaser Paketi"
    ],
    "techSpecs": [
      {
        "category": "Kamera & Aydınlatma",
        "items": [
          "Sony FX3 / FX6",
          "RGBWW Tüp Işıklar & Projeksiyon Sistemleri"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Müzik Klibinde Görsel Ritim Neden Hayatidir?",
        "content": "Müzik videosu bir şarkının dijital platformlardaki en büyük dinamiğidir; doğru renk ve kamera açıları şarkının akılda kalıcılığını katlar."
      }
    ],
    "faqs": [
      {
        "question": "Klip çekiminde mekân ve kostüm desteği veriyor musunuz?",
        "answer": "Evet, sanat yönetimi ekibimiz senaryoya uygun stüdyo, dış mekân, kostüm ve makyaj süreçlerini eksiksiz planlar."
      }
    ],
    "relatedProjectSlugs": [
      "gelmiyorsun-ezginin-gunlugu-eda-baba",
      "guney-marlen-eda-baba-seni-unutmak",
      "her-dakika-bir-saat-eda-baba"
    ]
  },
  {
    "categorySlug": "video-produksiyon",
    "categoryTitle": "Film ve Video Prodüksiyon",
    "slug": "havadan-drone-video",
    "title": "Lisanslı Havadan Drone Video ve Fotoğraf Çekimi",
    "metaTitle": "Lisanslı Havadan Drone Çekimi - 4K/5.1K İHA Pilotu WE24",
    "metaDescription": "SHGM onaylı ticari İHA pilotlarımız ve 5.1K Apple ProRes drone filomuz ile fabrikalar, araziler, mimari yapılar ve etkinlikler için havadan profesyonel çekim.",
    "keywords": [
      "drone video çekimi istanbul",
      "lisanslı iha pilotu",
      "havadan fabrika çekimi",
      "drone mimari çekim",
      "fpv drone çekimi"
    ],
    "heroTagline": "Gökyüzünden nefes kesici sinematik perspektifler ve yüksek çözünürlüklü hava görüntüleri.",
    "shortDescription": "SHGM onaylı ticari İHA pilotlarımız, 5.1K/4K sinema dronelarımız ve FPV sistemlerimiz ile fabrikalar, araziler, şantiyeler ve etkinlikler için profesyonel hava çekimleri gerçekleştiriyoruz.",
    "fullDescription": "Göklerdeki gözünüz olarak, en karmaşık ve hassas uçuş senaryolarını yasal izinlerle ve en yüksek güvenlik standartlarında yönetiyoruz.",
    "whyUs": [
      "SHGM Ticari İHA-1 Lisanslı Uzman Pilotlar",
      "5.1K Apple ProRes & 4K 120fps Çekim Kabiliyeti",
      "Kapalı Alan FPV Drone Çekim Yetkinliği",
      "Tüm Uçuş Sigorta ve İzin Süreçlerinin Yönetimi"
    ],
    "deliverables": [
      "5.1K / 4K RAW & ProRes Hava Görüntüleri",
      "Yüksek Çözünürlüklü Ortofoto ve Hava Fotoğrafları",
      "Kurgulanmış Teaser ve Renk Düzeltmeli Klipler"
    ],
    "process": [
      "Uçuş Lokasyonu & Hava Sahası İzinleri",
      "Uçuş Planlaması & Güvenlik Brifingi",
      "Gündoğumu/Günbatımı Sinematik Çekimler",
      "Renk ve Stabilizasyon Post-Prodüksiyonu"
    ],
    "techSpecs": [
      {
        "category": "Drone Filosu",
        "items": [
          "DJI Inspire 3 (8K)",
          "DJI Mavic 3 Cine (5.1K ProRes)",
          "Custom FPV Cinewhoop"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Neden Lisanslı İHA Pilotu ile Çalışmalısınız?",
        "content": "Hava çekimlerinde yasal izinlerin alınması, uçuş güvenliği ve yüksek rüzgar toleransı projenin sorunsuz tamamlanması için zorunludur."
      }
    ],
    "faqs": [
      {
        "question": "Uçuş izinlerini kim alıyor?",
        "answer": "Tüm uçuş izinleri ve SHGM bildirimleri WE24 Agency tarafından yasal mevzuata uygun şekilde yürütülür."
      }
    ],
    "relatedProjectSlugs": [
      "24-creative-we24-agency-aerial-showreel-2018",
      "fabrika-tanitim-filmi-kutes-we24-agency-fabrika-reklam-filmi"
    ]
  },
  {
    "categorySlug": "video-produksiyon",
    "categoryTitle": "Film ve Video Prodüksiyon",
    "slug": "360-vr-video",
    "title": "360 Derece Video ve VR / AR Deneyimleri",
    "metaTitle": "360 Derece Video & VR Sanal Tur Prodüksiyonu - WE24 Agency",
    "metaDescription": "İzleyiciye mekânın içindeymiş hissi veren 360 derece 8K interaktif video çekimleri, sanal turlar ve fuarlar için artırılmış/sanal gerçeklik görsel prodüksiyonu.",
    "keywords": [
      "360 derece video çekimi",
      "vr sanal tur",
      "sanal gerçeklik video",
      "360 fabrika turu",
      "interaktif video ajansı"
    ],
    "heroTagline": "İzleyicilerinizi mekânınızın tam merkezine yerleştiren 360 derece immersif görsel deneyimler.",
    "shortDescription": "Tesisler, müzeler, gayrimenkul projeleri ve fuarlar için 8K çözünürlükte 360 derece interaktif video çekimleri ve VR sanal tur prodüksiyonları hazırlıyoruz.",
    "fullDescription": "Sanal gerçeklik (VR) gözlükleriyle veya web üzerinden etkileşimli olarak gezilebilen 360 derece immersif videolarla mekânınızı dünyanın her yerine taşıyoruz.",
    "whyUs": [
      "8K Profesyonel 360 Kamera Sistemleri",
      "Kusursuz Dikiş (Stitching) ve Stabilizasyon",
      "Web, Mobil ve VR Başlıklarıyla %100 Uyum"
    ],
    "deliverables": [
      "8K / 4K 360 Derece Video Master",
      "Web Sanal Tur Entegrasyon Kodları",
      "VR Başlık (Oculus/Meta Quest) Uyumlu Uygulama"
    ],
    "process": [
      "Mekân Işık ve Rota Keşfi",
      "360 Kamera ile Pozisyonlama",
      "Stitching & Dikişsiz Birleştirme",
      "İnteraktif Buton ve Ses Ekleme"
    ],
    "techSpecs": [
      {
        "category": "360 Sistemleri",
        "items": [
          "Insta360 Pro 2 (8K 3D VR)",
          "Mesafe Sensörlü Stabilizatörler"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "360 Derece Videonun B2B Satışlardaki Gücü",
        "content": "Yurtdışındaki bir müşterinize fabrikanızı canlı olarak gezdirebilmek, güven inşa etmenin en hızlı yoludur."
      }
    ],
    "faqs": [
      {
        "question": "360 videolar web sitesine gömülebilir mi?",
        "answer": "Evet, YouTube 360 veya doğrudan web sitenize entegre edilebilir interaktif player formatında teslim ediyoruz."
      }
    ],
    "relatedProjectSlugs": [
      "barut-fethiye-sensatori-tanitim-filmi"
    ]
  },
  {
    "categorySlug": "video-produksiyon",
    "categoryTitle": "Film ve Video Prodüksiyon",
    "slug": "etkinlik-aftermovie",
    "title": "Etkinlik, Zirve ve Lansman Aftermovie Filmleri",
    "metaTitle": "Etkinlik Video Çekimi & Aftermovie Prodüksiyonu - WE24 Agency",
    "metaDescription": "Ürün lansmanları, uluslararası kongreler, ödül törenleri ve festivallerin enerjisini yansıtan dinamik aftermovie ve özet video prodüksiyonu.",
    "keywords": [
      "etkinlik video çekimi",
      "aftermovie prodüksiyon",
      "lansman videosu",
      "kongre video çekimi istanbul",
      "zirve tanıtım filmi"
    ],
    "heroTagline": "Etkinliğinizin coşkusunu, prestijini ve unutulmaz anlarını dinamik bir aftermovie ile ölümsüzleştirin.",
    "shortDescription": "Kongreler, ürün lansmanları, gala geceleri ve festivallerin atmosferini, katılımcı deneyimlerini ve marka anlarını yansıtan yüksek tempolu aftermovie filmleri hazırlıyoruz.",
    "fullDescription": "Aylar süren hazırlıklarla gerçekleşen etkinliklerinizin etkisini günlerle sınırlı bırakmayın; sinematik aftermovie prodüksiyonlarımızla etkinliğinizin prestijini dijitalde sürdürülebilir kılın.",
    "whyUs": [
      "Çok Kameralı Gezici ve Gimbal Set Ekipleri",
      "48 Saatte Hızlı Kurgu ve Sosyal Medya Teslimatı",
      "Katılımcı ve Konuşmacı Röportaj Yönetimi"
    ],
    "deliverables": [
      "2-3 Dk Sinematik Aftermovie (4K)",
      "Aynı Gün / Ertesi Gün Sosyal Medya Teaser Reels",
      "Konuşmacı Özet Klipleri"
    ],
    "process": [
      "Etkinlik Programı ve Çekim Planı Analizi",
      "Dinamik Çoklu Kamera Çekimi",
      "Hızlı Kurgu, Ses ve Renk Senkronizasyonu"
    ],
    "techSpecs": [
      {
        "category": "Ekipman",
        "items": [
          "Sony FX3 Kitleri",
          "Kablosuz Yaka Mikrofonları",
          "Mobil LED Setleri"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Bir Sonraki Etkinliğin En Güçlü Pazarlama Aracı: Aftermovie",
        "content": "Gelecek yılki sponsorluk ve bilet satışlarınızın teminatı, bu yılki etkinliğinizin ne kadar etkileyici göründüğüdür."
      }
    ],
    "faqs": [
      {
        "question": "Etkinlik sırasında sosyal medya için video üretiyor musunuz?",
        "answer": "Evet, yerinde hızlı kurgu (on-site editing) ekibimizle etkinlik devam ederken aynı gün Reels videoları teslim edebiliyoruz."
      }
    ],
    "relatedProjectSlugs": [
      "endocare-renewal-serisi-lansman-etkinlikleri-i-aftermovie",
      "vw-kristal-elma-official-aftermovie",
      "gazturman-gayan-50th-anniversary-event-trailer"
    ]
  },
  {
    "categorySlug": "canli-yayin-program",
    "categoryTitle": "Canlı Yayın ve Reji Prodüksiyonu",
    "slug": "reji-canli-yayin",
    "title": "Çok Kameralı Canlı Yayın ve Reji Yönetimi",
    "metaTitle": "Çok Kameralı Canlı Yayın ve Reji Yönetimi - Canlı Yayın ve Reji Prodüksiyonu WE24 Agency İstanbul",
    "metaDescription": "Çok Kameralı Canlı Yayın ve Reji Yönetimi alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "reji canlı yayın",
      "çok kameralı çekim",
      "canlı yayın prodüksiyon"
    ],
    "heroTagline": "Çok Kameralı Canlı Yayın ve Reji Yönetimi alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "ATEM 4K reji mikserleri, telsiz kameralar, reji içi anons ve profesyonel görüntü yönetimiyle TV yayın kalitesinde çok kameralı canlı akış.",
    "fullDescription": "WE24 Agency olarak canlı yayın ve reji prodüksiyonu disiplininde yer alan Çok Kameralı Canlı Yayın ve Reji Yönetimi alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Çok Kameralı Canlı Yayın ve Reji Yönetimi Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında çok kameralı canlı yayın ve reji yönetimi çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Çok Kameralı Canlı Yayın ve Reji Yönetimi süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "canli-yayin-program",
    "categoryTitle": "Canlı Yayın ve Reji Prodüksiyonu",
    "slug": "espor-gaming-yayin",
    "title": "E-Spor & Gaming Turnuva Yayınları",
    "metaTitle": "E-Spor & Gaming Turnuva Yayınları - Canlı Yayın ve Reji Prodüksiyonu WE24 Agency İstanbul",
    "metaDescription": "E-Spor & Gaming Turnuva Yayınları alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "espor canlı yayın",
      "gaming turnuva prodüksiyonu",
      "twitch yayın altyapısı"
    ],
    "heroTagline": "E-Spor & Gaming Turnuva Yayınları alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Kristal Piksel, TaleWorlds ve büyük oyun finallerinde kanıtlanmış; anlık oyun içi skor tabloları, oyuncu kameraları ve dinamik spiker masası prodüksiyonu.",
    "fullDescription": "WE24 Agency olarak canlı yayın ve reji prodüksiyonu disiplininde yer alan E-Spor & Gaming Turnuva Yayınları alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "E-Spor & Gaming Turnuva Yayınları Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında e-spor & gaming turnuva yayınları çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "E-Spor & Gaming Turnuva Yayınları süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "canli-yayin-program",
    "categoryTitle": "Canlı Yayın ve Reji Prodüksiyonu",
    "slug": "hibrit-etkinlik-zirve",
    "title": "Hibrit Etkinlik & Uluslararası Zirveler",
    "metaTitle": "Hibrit Etkinlik & Uluslararası Zirveler - Canlı Yayın ve Reji Prodüksiyonu WE24 Agency İstanbul",
    "metaDescription": "Hibrit Etkinlik & Uluslararası Zirveler alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "hibrit kongre yayını",
      "online zirve prodüksiyonu",
      "zoom canlı yayın entegrasyonu"
    ],
    "heroTagline": "Hibrit Etkinlik & Uluslararası Zirveler alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Salondaki fiziksel izleyiciler ile dünyanın dört bir yanındaki online katılımcıları çift yönlü video, anlık oylama ve soru-cevap ile buluşturan altyapı.",
    "fullDescription": "WE24 Agency olarak canlı yayın ve reji prodüksiyonu disiplininde yer alan Hibrit Etkinlik & Uluslararası Zirveler alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Hibrit Etkinlik & Uluslararası Zirveler Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında hibrit etkinlik & uluslararası zirveler çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Hibrit Etkinlik & Uluslararası Zirveler süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "canli-yayin-program",
    "categoryTitle": "Canlı Yayın ve Reji Prodüksiyonu",
    "slug": "simulcast-yayin",
    "title": "Çoklu Platform Eşzamanlı Yayın (Simulcast)",
    "metaTitle": "Çoklu Platform Eşzamanlı Yayın (Simulcast) - Canlı Yayın ve Reji Prodüksiyonu WE24 Agency İstanbul",
    "metaDescription": "Çoklu Platform Eşzamanlı Yayın (Simulcast) alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "simulcast yayın",
      "çoklu platform yayını",
      "youtube linkedin canlı yayın"
    ],
    "heroTagline": "Çoklu Platform Eşzamanlı Yayın (Simulcast) alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Tek bir yayın akışını aynı anda YouTube, LinkedIn Live, Twitter (X), Facebook ve özel web portallarına kayıpsız ve gecikmesiz olarak dağıtma.",
    "fullDescription": "WE24 Agency olarak canlı yayın ve reji prodüksiyonu disiplininde yer alan Çoklu Platform Eşzamanlı Yayın (Simulcast) alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Çoklu Platform Eşzamanlı Yayın (Simulcast) Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında çoklu platform eşzamanlı yayın (simulcast) çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Çoklu Platform Eşzamanlı Yayın (Simulcast) süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "canli-yayin-program",
    "categoryTitle": "Canlı Yayın ve Reji Prodüksiyonu",
    "slug": "studyo-programciligi",
    "title": "Stüdyo Programcılığı & Talk Show Formatları",
    "metaTitle": "Stüdyo Programcılığı & Talk Show Formatları - Canlı Yayın ve Reji Prodüksiyonu WE24 Agency İstanbul",
    "metaDescription": "Stüdyo Programcılığı & Talk Show Formatları alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "stüdyo program çekimi",
      "youtube talk show prodüksiyon",
      "webcast stüdyo kiralama"
    ],
    "heroTagline": "Stüdyo Programcılığı & Talk Show Formatları alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "YouTube ve TV formatları için özel stüdyo dekoru, profesyonel reji, prompter desteği ve dinamik jenerik/alt yazı entegrasyonu.",
    "fullDescription": "WE24 Agency olarak canlı yayın ve reji prodüksiyonu disiplininde yer alan Stüdyo Programcılığı & Talk Show Formatları alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Stüdyo Programcılığı & Talk Show Formatları Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında stüdyo programcılığı & talk show formatları çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Stüdyo Programcılığı & Talk Show Formatları süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "post-produksiyon",
    "categoryTitle": "Post-Prodüksiyon, Renk ve VFX",
    "slug": "kurgu-montaj",
    "title": "Profesyonel Kurgu & Montaj",
    "metaTitle": "Profesyonel Kurgu & Montaj - Post-Prodüksiyon, Renk ve VFX WE24 Agency İstanbul",
    "metaDescription": "Profesyonel Kurgu & Montaj alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "video kurgu",
      "profesyonel montaj",
      "video düzenleme hizmeti"
    ],
    "heroTagline": "Profesyonel Kurgu & Montaj alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Ritim duygusu yüksek, izleyiciyi içine çeken anlatı yapısı, dinamik sahne geçişleri ve hikâyenin duygusunu zirveye taşıyan profesyonel kurgu.",
    "fullDescription": "WE24 Agency olarak post-prodüksiyon, renk ve vfx disiplininde yer alan Profesyonel Kurgu & Montaj alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Profesyonel Kurgu & Montaj Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında profesyonel kurgu & montaj çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Profesyonel Kurgu & Montaj süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "post-produksiyon",
    "categoryTitle": "Post-Prodüksiyon, Renk ve VFX",
    "slug": "renk-duzenleme",
    "title": "DaVinci Resolve Renk Düzenleme (Color Grading)",
    "metaTitle": "DaVinci Resolve Renk Düzenleme (Color Grading) - Post-Prodüksiyon, Renk ve VFX WE24 Agency İstanbul",
    "metaDescription": "DaVinci Resolve Renk Düzenleme (Color Grading) alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "color grading istanbul",
      "davinci resolve renk",
      "sinematik renk düzenleme"
    ],
    "heroTagline": "DaVinci Resolve Renk Düzenleme (Color Grading) alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Flanders Scientific referans monitörlerinde RAW/Log görüntülere özel renk atmosferi, cilt tonu optimizasyonu ve sinematik renk ayrımı.",
    "fullDescription": "WE24 Agency olarak post-prodüksiyon, renk ve vfx disiplininde yer alan DaVinci Resolve Renk Düzenleme (Color Grading) alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "DaVinci Resolve Renk Düzenleme (Color Grading) Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında davinci resolve renk düzenleme (color grading) çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "DaVinci Resolve Renk Düzenleme (Color Grading) süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "post-produksiyon",
    "categoryTitle": "Post-Prodüksiyon, Renk ve VFX",
    "slug": "vfx-gorsel-efekt",
    "title": "VFX & Görsel Efekt Stüdyosu",
    "metaTitle": "VFX & Görsel Efekt Stüdyosu - Post-Prodüksiyon, Renk ve VFX WE24 Agency İstanbul",
    "metaDescription": "VFX & Görsel Efekt Stüdyosu alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "vfx stüdyosu",
      "görsel efekt yapımı",
      "green screen compositing"
    ],
    "heroTagline": "VFX & Görsel Efekt Stüdyosu alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Yeşil perde (green screen) birleştirme, nesne silme/clean-up, ürün dijitalleştirme, 3D parça entegrasyonu ve fotogerçekçi görsel efektler.",
    "fullDescription": "WE24 Agency olarak post-prodüksiyon, renk ve vfx disiplininde yer alan VFX & Görsel Efekt Stüdyosu alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "VFX & Görsel Efekt Stüdyosu Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında vfx & görsel efekt stüdyosu çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "VFX & Görsel Efekt Stüdyosu süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "post-produksiyon",
    "categoryTitle": "Post-Prodüksiyon, Renk ve VFX",
    "slug": "animasyon-motion-graphics",
    "title": "2D / 3D Animasyon & Motion Design",
    "metaTitle": "2D / 3D Animasyon & Motion Design - Post-Prodüksiyon, Renk ve VFX WE24 Agency İstanbul",
    "metaDescription": "2D / 3D Animasyon & Motion Design alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "3d animasyon istanbul",
      "motion graphics ajansı",
      "endüstriyel 3d modelleme"
    ],
    "heroTagline": "2D / 3D Animasyon & Motion Design alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Karmaşık teknik mekanizmaları basitleştiren 3D endüstriyel patlatma animasyonları, infografik videolar ve göz alıcı kinetik tipografiler.",
    "fullDescription": "WE24 Agency olarak post-prodüksiyon, renk ve vfx disiplininde yer alan 2D / 3D Animasyon & Motion Design alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "2D / 3D Animasyon & Motion Design Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında 2d / 3d animasyon & motion design çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "2D / 3D Animasyon & Motion Design süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "post-produksiyon",
    "categoryTitle": "Post-Prodüksiyon, Renk ve VFX",
    "slug": "ses-tasarimi-mastering",
    "title": "Ses Tasarımı & Mastering",
    "metaTitle": "Ses Tasarımı & Mastering - Post-Prodüksiyon, Renk ve VFX WE24 Agency İstanbul",
    "metaDescription": "Ses Tasarımı & Mastering alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "ses tasarımı",
      "video ses miksajı",
      "ses mastering"
    ],
    "heroTagline": "Ses Tasarımı & Mastering alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Görseli tamamlayan atmosfer sesleri, foley efektleri, frekans temizliği, profesyonel ses miksajı ve EBU R128 yayın standardı mastering.",
    "fullDescription": "WE24 Agency olarak post-prodüksiyon, renk ve vfx disiplininde yer alan Ses Tasarımı & Mastering alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Ses Tasarımı & Mastering Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında ses tasarımı & mastering çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Ses Tasarımı & Mastering süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "fotograf-produksiyon",
    "categoryTitle": "Fotoğraf Prodüksiyonu",
    "slug": "mimari-fotograflama",
    "title": "Mimari & Mekân Fotoğraflama",
    "metaTitle": "Mimari & Mekân Fotoğraflama - Fotoğraf Prodüksiyonu WE24 Agency İstanbul",
    "metaDescription": "Mimari & Mekân Fotoğraflama alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "mimari fotoğraf çekimi",
      "otel fotoğrafçılığı",
      "iç mekan fotoğrafçısı istanbul"
    ],
    "heroTagline": "Mimari & Mekân Fotoğraflama alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Oteller, lüks konut projeleri, restoranlar ve şirket genel merkezleri için perspektif düzeltmeli tilt-shift lenslerle iç ve dış cephe mimari çekimleri.",
    "fullDescription": "WE24 Agency olarak fotoğraf prodüksiyonu disiplininde yer alan Mimari & Mekân Fotoğraflama alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Mimari & Mekân Fotoğraflama Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında mimari & mekân fotoğraflama çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Mimari & Mekân Fotoğraflama süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "fotograf-produksiyon",
    "categoryTitle": "Fotoğraf Prodüksiyonu",
    "slug": "endustriyel-fotografcilik",
    "title": "Endüstriyel & Fabrika Fotoğrafçılığı",
    "metaTitle": "Endüstriyel & Fabrika Fotoğrafçılığı - Fotoğraf Prodüksiyonu WE24 Agency İstanbul",
    "metaDescription": "Endüstriyel & Fabrika Fotoğrafçılığı alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "fabrika fotoğrafçılığı",
      "sanayi tesisi fotoğraf çekimi",
      "kurumsal fotoğrafçı"
    ],
    "heroTagline": "Endüstriyel & Fabrika Fotoğrafçılığı alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Üretim parkurları, ağır sanayi tesisleri, Ar-Ge merkezleri ve saha operasyonlarının kurumsal prestijini yansıtan katalog kalitesinde fotoğraflar.",
    "fullDescription": "WE24 Agency olarak fotoğraf prodüksiyonu disiplininde yer alan Endüstriyel & Fabrika Fotoğrafçılığı alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Endüstriyel & Fabrika Fotoğrafçılığı Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında endüstriyel & fabrika fotoğrafçılığı çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Endüstriyel & Fabrika Fotoğrafçılığı süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "fotograf-produksiyon",
    "categoryTitle": "Fotoğraf Prodüksiyonu",
    "slug": "urun-fotografciligi",
    "title": "Ürün & E-Ticaret Fotoğraf Çekimi",
    "metaTitle": "Ürün & E-Ticaret Fotoğraf Çekimi - Fotoğraf Prodüksiyonu WE24 Agency İstanbul",
    "metaDescription": "Ürün & E-Ticaret Fotoğraf Çekimi alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "ürün fotoğraf çekimi",
      "e-ticaret beyaz fon çekim",
      "kozmetik konsept çekimi"
    ],
    "heroTagline": "Ürün & E-Ticaret Fotoğraf Çekimi alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Kozmetik, gıda, mücevher, tekstil ve endüstriyel parçalar için stüdyo ortamında gölgesiz dekupe, konsept ve ghost manken çekimleri.",
    "fullDescription": "WE24 Agency olarak fotoğraf prodüksiyonu disiplininde yer alan Ürün & E-Ticaret Fotoğraf Çekimi alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Ürün & E-Ticaret Fotoğraf Çekimi Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında ürün & e-ticaret fotoğraf çekimi çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Ürün & E-Ticaret Fotoğraf Çekimi süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "fotograf-produksiyon",
    "categoryTitle": "Fotoğraf Prodüksiyonu",
    "slug": "model-moda-fotografciligi",
    "title": "Model & Moda Fotoğraf Çekimleri",
    "metaTitle": "Model & Moda Fotoğraf Çekimleri - Fotoğraf Prodüksiyonu WE24 Agency İstanbul",
    "metaDescription": "Model & Moda Fotoğraf Çekimleri alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "moda fotoğraf çekimi",
      "model stüdyo çekimi",
      "lookbook fotoğrafçılığı"
    ],
    "heroTagline": "Model & Moda Fotoğraf Çekimleri alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Lookbook, katalog ve kampanya görselleri için cast seçimi, styling, makyaj ve stüdyo/dış mekân moda fotoğraf prodüksiyonu.",
    "fullDescription": "WE24 Agency olarak fotoğraf prodüksiyonu disiplininde yer alan Model & Moda Fotoğraf Çekimleri alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Model & Moda Fotoğraf Çekimleri Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında model & moda fotoğraf çekimleri çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Model & Moda Fotoğraf Çekimleri süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "fotograf-produksiyon",
    "categoryTitle": "Fotoğraf Prodüksiyonu",
    "slug": "havadan-drone-fotograf",
    "title": "Havadan Drone Fotoğrafçılığı",
    "metaTitle": "Havadan Drone Fotoğrafçılığı - Fotoğraf Prodüksiyonu WE24 Agency İstanbul",
    "metaDescription": "Havadan Drone Fotoğrafçılığı alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "hava fotoğrafı çekimi",
      "drone fotoğrafçı",
      "arsa arazi drone fotoğrafı"
    ],
    "heroTagline": "Havadan Drone Fotoğrafçılığı alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Fabrika arazileri, limanlar, şantiyeler ve şehir peyzajları için yüksek çözünürlüklü RAW hava fotoğrafları ve ortofoto haritalama.",
    "fullDescription": "WE24 Agency olarak fotoğraf prodüksiyonu disiplininde yer alan Havadan Drone Fotoğrafçılığı alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Havadan Drone Fotoğrafçılığı Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında havadan drone fotoğrafçılığı çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Havadan Drone Fotoğrafçılığı süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "dijital-ve-sosyal-medya",
    "categoryTitle": "Dijital Strateji ve Sosyal Medya Yönetimi",
    "slug": "sosyal-medya-hesap-yonetimi",
    "title": "Sosyal Medya Hesap Yönetimi",
    "metaTitle": "Sosyal Medya Hesap Yönetimi - Dijital Strateji ve Sosyal Medya Yönetimi WE24 Agency İstanbul",
    "metaDescription": "Sosyal Medya Hesap Yönetimi alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "sosyal medya yönetimi",
      "instagram hesap yönetimi",
      "sosyal medya danışmanlığı"
    ],
    "heroTagline": "Sosyal Medya Hesap Yönetimi alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Marka diline uygun aylık editoryal içerik takvimi, profesyonel tasarım şablonları, metin yazarlığı ve topluluk etkileşimi yönetimi.",
    "fullDescription": "WE24 Agency olarak dijital strateji ve sosyal medya yönetimi disiplininde yer alan Sosyal Medya Hesap Yönetimi alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Sosyal Medya Hesap Yönetimi Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında sosyal medya hesap yönetimi çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Sosyal Medya Hesap Yönetimi süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "dijital-ve-sosyal-medya",
    "categoryTitle": "Dijital Strateji ve Sosyal Medya Yönetimi",
    "slug": "dijital-icerik-uretimi",
    "title": "Dinamik Dikey Video & Reels Üretimi",
    "metaTitle": "Dinamik Dikey Video & Reels Üretimi - Dijital Strateji ve Sosyal Medya Yönetimi WE24 Agency İstanbul",
    "metaDescription": "Dinamik Dikey Video & Reels Üretimi alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "reels çekimi",
      "tiktok içerik üretimi",
      "viral video ajansı"
    ],
    "heroTagline": "Dinamik Dikey Video & Reels Üretimi alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Instagram Reels, YouTube Shorts ve TikTok algoritmalarının sevdiği, ilk 3 saniyede izleyiciyi yakalayan profesyonel kısa video prodüksiyonları.",
    "fullDescription": "WE24 Agency olarak dijital strateji ve sosyal medya yönetimi disiplininde yer alan Dinamik Dikey Video & Reels Üretimi alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Dinamik Dikey Video & Reels Üretimi Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında dinamik dikey video & reels üretimi çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Dinamik Dikey Video & Reels Üretimi süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "dijital-ve-sosyal-medya",
    "categoryTitle": "Dijital Strateji ve Sosyal Medya Yönetimi",
    "slug": "sosyal-medya-reklam-yonetimi",
    "title": "Performans & Sosyal Medya Reklamları",
    "metaTitle": "Performans & Sosyal Medya Reklamları - Dijital Strateji ve Sosyal Medya Yönetimi WE24 Agency İstanbul",
    "metaDescription": "Performans & Sosyal Medya Reklamları alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "meta reklam yönetimi",
      "instagram reklam verme",
      "performans pazarlama ajansı"
    ],
    "heroTagline": "Performans & Sosyal Medya Reklamları alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Meta Ads Manager, Google Ads ve TikTok Ads üzerinden ROAS (reklam harcaması getirisi) odaklı hedefleme, A/B testleri ve bütçe optimizasyonu.",
    "fullDescription": "WE24 Agency olarak dijital strateji ve sosyal medya yönetimi disiplininde yer alan Performans & Sosyal Medya Reklamları alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Performans & Sosyal Medya Reklamları Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında performans & sosyal medya reklamları çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Performans & Sosyal Medya Reklamları süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "dijital-ve-sosyal-medya",
    "categoryTitle": "Dijital Strateji ve Sosyal Medya Yönetimi",
    "slug": "youtube-kanal-yonetimi-seo",
    "title": "YouTube Kanal Yönetimi & Video SEO",
    "metaTitle": "YouTube Kanal Yönetimi & Video SEO - Dijital Strateji ve Sosyal Medya Yönetimi WE24 Agency İstanbul",
    "metaDescription": "YouTube Kanal Yönetimi & Video SEO alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "youtube seo",
      "youtube kanal yönetimi",
      "youtube izlenme artırma"
    ],
    "heroTagline": "YouTube Kanal Yönetimi & Video SEO alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Tıklama oranı (CTR) yüksek kapak görselleri (thumbnail), anahtar kelime etiketleme, oynatma listesi stratejisi ve kanal büyüme danışmanlığı.",
    "fullDescription": "WE24 Agency olarak dijital strateji ve sosyal medya yönetimi disiplininde yer alan YouTube Kanal Yönetimi & Video SEO alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "YouTube Kanal Yönetimi & Video SEO Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında youtube kanal yönetimi & video seo çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "YouTube Kanal Yönetimi & Video SEO süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "tasarim-ve-marka",
    "categoryTitle": "Marka Kimliği ve Grafik Tasarım",
    "slug": "kurumsal-kimlik-tasarimi",
    "title": "Kurumsal Kimlik & Logo Tasarımı",
    "metaTitle": "Kurumsal Kimlik & Logo Tasarımı - Marka Kimliği ve Grafik Tasarım WE24 Agency İstanbul",
    "metaDescription": "Kurumsal Kimlik & Logo Tasarımı alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "logo tasarımı",
      "kurumsal kimlik rehberi",
      "brandbook hazırlama"
    ],
    "heroTagline": "Kurumsal Kimlik & Logo Tasarımı alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Markanızın karakterini yansıtan özgün logo, renk kodları, kurumsal font ailesi, kartvizit, antetli kağıt ve kapsamlı marka kılavuzu (Brandbook).",
    "fullDescription": "WE24 Agency olarak marka kimliği ve grafik tasarım disiplininde yer alan Kurumsal Kimlik & Logo Tasarımı alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Kurumsal Kimlik & Logo Tasarımı Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında kurumsal kimlik & logo tasarımı çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Kurumsal Kimlik & Logo Tasarımı süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "tasarim-ve-marka",
    "categoryTitle": "Marka Kimliği ve Grafik Tasarım",
    "slug": "sosyal-medya-tasarimi",
    "title": "Sosyal Medya Tasarım Sistemleri",
    "metaTitle": "Sosyal Medya Tasarım Sistemleri - Marka Kimliği ve Grafik Tasarım WE24 Agency İstanbul",
    "metaDescription": "Sosyal Medya Tasarım Sistemleri alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "sosyal medya tasarım",
      "instagram post şablonu",
      "banner tasarımı"
    ],
    "heroTagline": "Sosyal Medya Tasarım Sistemleri alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Instagram, LinkedIn ve diğer mecralar için tutarlı, marka renkleriyle uyumlu, modern ve dikkat çekici görsel şablonlar.",
    "fullDescription": "WE24 Agency olarak marka kimliği ve grafik tasarım disiplininde yer alan Sosyal Medya Tasarım Sistemleri alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Sosyal Medya Tasarım Sistemleri Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında sosyal medya tasarım sistemleri çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Sosyal Medya Tasarım Sistemleri süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "tasarim-ve-marka",
    "categoryTitle": "Marka Kimliği ve Grafik Tasarım",
    "slug": "dergi-sayfa-tasarimi-mizanpaj",
    "title": "Katalog, Dergi & Mizanpaj (Editoryal)",
    "metaTitle": "Katalog, Dergi & Mizanpaj (Editoryal) - Marka Kimliği ve Grafik Tasarım WE24 Agency İstanbul",
    "metaDescription": "Katalog, Dergi & Mizanpaj (Editoryal) alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "katalog tasarımı",
      "dergi mizanpaj",
      "faaliyet raporu tasarımı"
    ],
    "heroTagline": "Katalog, Dergi & Mizanpaj (Editoryal) alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Basılı ve dijital ürün katalogları, prestij dergileri, kurumsal faaliyet raporları ve broşürler için uluslararası standartlarda mizanpaj.",
    "fullDescription": "WE24 Agency olarak marka kimliği ve grafik tasarım disiplininde yer alan Katalog, Dergi & Mizanpaj (Editoryal) alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Katalog, Dergi & Mizanpaj (Editoryal) Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında katalog, dergi & mizanpaj (editoryal) çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Katalog, Dergi & Mizanpaj (Editoryal) süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "tasarim-ve-marka",
    "categoryTitle": "Marka Kimliği ve Grafik Tasarım",
    "slug": "ambalaj-tasarimi",
    "title": "Ambalaj & Etiket Tasarımı",
    "metaTitle": "Ambalaj & Etiket Tasarımı - Marka Kimliği ve Grafik Tasarım WE24 Agency İstanbul",
    "metaDescription": "Ambalaj & Etiket Tasarımı alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "ambalaj tasarımı",
      "etiket tasarımı",
      "kutu tasarım ajansı"
    ],
    "heroTagline": "Ambalaj & Etiket Tasarımı alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Rafta fark yaratan, tüketiciyi satın almaya teşvik eden, malzeme ve baskı teknikleriyle kusursuz uyumlu ambalaj çözümleri.",
    "fullDescription": "WE24 Agency olarak marka kimliği ve grafik tasarım disiplininde yer alan Ambalaj & Etiket Tasarımı alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Ambalaj & Etiket Tasarımı Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında ambalaj & etiket tasarımı çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Ambalaj & Etiket Tasarımı süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "web-ve-yazilim",
    "categoryTitle": "Web Geliştirme ve Özel Yazılım",
    "slug": "web-tasarim-yazilim",
    "title": "Kurumsal Web Tasarım & Yazılım",
    "metaTitle": "Kurumsal Web Tasarım & Yazılım - Web Geliştirme ve Özel Yazılım WE24 Agency İstanbul",
    "metaDescription": "Kurumsal Web Tasarım & Yazılım alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "kurumsal web sitesi",
      "web tasarım istanbul",
      "hızlı web yazılım"
    ],
    "heroTagline": "Kurumsal Web Tasarım & Yazılım alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Markanızın prestijini dijitale taşıyan, ultra hızlı açılan, Core Web Vitals standartlarına tam uyumlu ve modern kurumsal siteler.",
    "fullDescription": "WE24 Agency olarak web geliştirme ve özel yazılım disiplininde yer alan Kurumsal Web Tasarım & Yazılım alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Kurumsal Web Tasarım & Yazılım Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında kurumsal web tasarım & yazılım çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Kurumsal Web Tasarım & Yazılım süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "web-ve-yazilim",
    "categoryTitle": "Web Geliştirme ve Özel Yazılım",
    "slug": "ozel-yazilim-gelistirme",
    "title": "Özel Web Uygulamaları & SaaS",
    "metaTitle": "Özel Web Uygulamaları & SaaS - Web Geliştirme ve Özel Yazılım WE24 Agency İstanbul",
    "metaDescription": "Özel Web Uygulamaları & SaaS alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "özel yazılım",
      "saas geliştirme",
      "web uygulaması yapımı"
    ],
    "heroTagline": "Özel Web Uygulamaları & SaaS alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Şirket içi iş akışlarınızı otomatize eden paneller, müşteri portalları, rezervasyon/teklif motorları ve ölçeklenebilir SaaS yazılımları.",
    "fullDescription": "WE24 Agency olarak web geliştirme ve özel yazılım disiplininde yer alan Özel Web Uygulamaları & SaaS alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Özel Web Uygulamaları & SaaS Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında özel web uygulamaları & saas çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Özel Web Uygulamaları & SaaS süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "web-ve-yazilim",
    "categoryTitle": "Web Geliştirme ve Özel Yazılım",
    "slug": "e-ticaret-altyapisi",
    "title": "E-Ticaret Altyapıları & Entegrasyonlar",
    "metaTitle": "E-Ticaret Altyapıları & Entegrasyonlar - Web Geliştirme ve Özel Yazılım WE24 Agency İstanbul",
    "metaDescription": "E-Ticaret Altyapıları & Entegrasyonlar alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "e-ticaret sitesi",
      "online mağaza kurulumu",
      "ödeme sistemi entegrasyonu"
    ],
    "heroTagline": "E-Ticaret Altyapıları & Entegrasyonlar alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "Yüksek dönüşüm oranlı sepet ve ödeme adımları, ERP/Muhasebe/Kargo API entegrasyonları ve güvenli online satış sistemleri.",
    "fullDescription": "WE24 Agency olarak web geliştirme ve özel yazılım disiplininde yer alan E-Ticaret Altyapıları & Entegrasyonlar alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "E-Ticaret Altyapıları & Entegrasyonlar Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında e-ticaret altyapıları & entegrasyonlar çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "E-Ticaret Altyapıları & Entegrasyonlar süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  },
  {
    "categorySlug": "web-ve-yazilim",
    "categoryTitle": "Web Geliştirme ve Özel Yazılım",
    "slug": "mobil-yazilim",
    "title": "Mobil Yazılım & PWA",
    "metaTitle": "Mobil Yazılım & PWA - Web Geliştirme ve Özel Yazılım WE24 Agency İstanbul",
    "metaDescription": "Mobil Yazılım & PWA alanında profesyonel prodüksiyon, teknoloji ve yaratıcı ajans hizmetleri. WE24 Agency ile markanızı geleceğe taşıyın.",
    "keywords": [
      "mobil uygulama geliştirme",
      "pwa web sitesi",
      "mobil yazılım ajansı"
    ],
    "heroTagline": "Mobil Yazılım & PWA alanında markanıza değer katan yüksek standartlı profesyonel çözümler.",
    "shortDescription": "iOS ve Android uyumlu mobil uygulamalar, Progressive Web App (PWA) çözümleri ve mobil odaklı kullanıcı deneyimi tasarımları.",
    "fullDescription": "WE24 Agency olarak web geliştirme ve özel yazılım disiplininde yer alan Mobil Yazılım & PWA alanında 15 yılı aşkın deneyim, son teknoloji altyapı ve uzman kadromuzla kurumsal markalara uçtan uca hizmet sunuyoruz. İhtiyacınıza özel strateji geliştiriyor, süreçleri titizlikle yönetiyor ve ölçülebilir başarı sağlıyoruz.",
    "whyUs": [
      "15+ Yıllık Sektörel Uzmanlık ve Alanında Lider Ekip",
      "Son Teknoloji Ekipman ve Yazılım Altyapısı",
      "Uçtan Uca Süreç Yönetimi ve Şeffaf İletişim",
      "Zamanında ve Kusursuz Kalitede Teslimat Garantisi"
    ],
    "deliverables": [
      "Yüksek Çözünürlüklü Master Dosyalar",
      "Platformlara Özel Dijital Çıktılar",
      "Tüm Kaynak Dosyalar ve Kullanım Kılavuzu"
    ],
    "process": [
      "1. Analiz & Brifing: Marka hedefleri ve proje kapsamı belirlenir.",
      "2. Strateji & Tasarım: İhtiyaca yönelik konsept ve iş akışı planlanır.",
      "3. Uygulama & Prodüksiyon: Uzman kadro ve profesyonel ekipmanla üretim gerçekleştirilir.",
      "4. Kalite Kontrol & Revizyon: Detaylı testler ve müşteri geri bildirimleri tamamlanır.",
      "5. Yayına Alma & Teslimat: Nihai çıktılar tüm formatlarda teslim edilir."
    ],
    "techSpecs": [
      {
        "category": "Teknoloji Standartları",
        "items": [
          "Endüstri Lideri Donanım & Yazılım Altyapısı",
          "Yüksek Güvenlikli Yedekleme ve Arşivleme"
        ]
      }
    ],
    "articleSections": [
      {
        "heading": "Mobil Yazılım & PWA Hizmetinin Markanıza Sağladığı Stratejik Avantajlar",
        "content": "Günümüz rekabetçi pazarında mobil yazılım & pwa çalışmalarının profesyonel standartlarda yürütülmesi; marka prestijini artırırken dönüşüm oranlarını ve müşteri sadakatini doğrudan yükseltir.",
        "subPoints": [
          "Marka Bilinirliğini ve Güvenini Artırır",
          "Rakipleriniz Arasında Ayrışan Bir Konumlandırma Sağlar",
          "Ölçülebilir ve Sürdürülebilir Sonuçlar Üretir"
        ]
      }
    ],
    "faqs": [
      {
        "question": "Mobil Yazılım & PWA süreci nasıl başlar?",
        "answer": "Ekibimizle iletişime geçtikten sonra projenizin hedeflerini dinliyor, size özel kapsam ve zaman planı içeren bir teklif sunuyoruz."
      },
      {
        "question": "Teslimat süresi ne kadardır?",
        "answer": "Projenin kapsamına bağlı olarak genellikle 1 ila 3 hafta içinde nihai teslimat sağlanmaktadır."
      }
    ],
    "relatedProjectSlugs": []
  }
];
